import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export class CreateEventAttendant {
  public userId: string = '';
  public additionalInfo: string = '';

  public rules: { [key: string]: FormValidationFunction[] } = {
    userId: [
      (v: string) => !!v || 'This field is required.',
    ],
    additionalInfo: [],
  };
}
